export const GET_ME_REQUEST = 'GET_ME_REQUEST';
export const GET_ME_FAILURE = 'GET_ME_FAILURE';
export const GET_ME_SUCCESS = 'GET_ME_SUCCESS';

export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUPS_FAILURE = 'GET_GROUPS_FAILURE';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';

export const UPDATE_USER_PROFILE_REQUEST = 'UPDATE_USER_PROFILE_REQUEST';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_PROFILE_FAILURE';

export const GET_COMPANY_USERS_REQUEST = 'GET_COMPANY_USERS_REQUEST';
export const GET_COMPANY_USERS_FAILURE = 'GET_COMPANY_USERS_FAILURE';
export const GET_COMPANY_USERS_SUCCESS = 'GET_COMPANY_USERS_SUCCESS';

export const UPDATE_COMPANY_USER_REQUEST = 'UPDATE_COMPANY_USER_REQUEST';
export const UPDATE_COMPANY_USER_SUCCESS = 'UPDATE_COMPANY_USER_SUCCESS';
export const UPDATE_COMPANY_USER_FAILURE = 'UPDATE_COMPANY_USER_FAILURE';

export const UPDATE_USER_LOCALE_REQUEST = 'UPDATE_USER_LOCALE_REQUEST';
export const UPDATE_USER_LOCALE_SUCCESS = 'UPDATE_USER_LOCALE_SUCCESS';
export const UPDATE_USER_LOCALE_FAILURE = 'UPDATE_USER_LOCALE_FAILURE';

export const UPDATE_USER_PASSWORD_REQUEST = 'UPDATE_USER_PASSWORD_REQUEST';
export const UPDATE_USER_PASSWORD_SUCCESS = 'UPDATE_USER_PASSWORD_SUCCESS';
export const UPDATE_USER_PASSWORD_FAILURE = 'UPDATE_USER_PASSWORD_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/user/mutation-types.js